import * as React from "react";
import { StatisticsService } from "src/share/services/statistics";
import { ChartHeader } from "./ChartHeader";
import ChartLoader from "src/share/components/ChartLoader/ChartLoader";
import { YearLoader } from "src/share/components/ChartLoader/YearLoader";
import LineChart from "src/share/components/Chart/LineChart";
import { CaseTypes } from "src/share/types/case/case";

type Props = {
  agencyCode: string;
  range?: { lte: number; gte: number };
  status?: "ALL" | "open" | "closed";
  caseType?: CaseTypes | "ALL";
  loadingReport: string;
  onReportDownload: () => void;
};

const MonthlyHighlights: React.FC<Props> = ({
  agencyCode,
  status,
  caseType,
  range,
  loadingReport,
  onReportDownload,
}) => {
  const [stats, setStats] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    async function fetchData(): Promise<void> {
      setIsLoading(true);
      const newStats = await StatisticsService.getMonthlyHighlights(
        agencyCode,
        status,
        caseType,
        range
      );
      setStats(newStats);
      setIsLoading(false);
    }
    fetchData();
  }, [agencyCode, status, caseType, range]);

  return (
    <div className="white-background monthly-highlights">
      <ChartHeader
        text={"Monthly Highlights "}
        id="monthlyHighlights"
        action={onReportDownload}
        showDownloadReport={true}
        loading={loadingReport}
      />
      {
        <ChartLoader
          chart={LineChart}
          loader={YearLoader}
          data={stats}
          loading={isLoading}
        />
      }
    </div>
  );
};

export default React.memo(MonthlyHighlights);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Home/components/MonthlyHighlights.tsx